const active = location.hostname !== 'localhost'

export const ANALYTICS_START = 1
export const ANALYTICS_COMPLETE = 2
export const ANALYTICS_FAIL = 3

export class AnalyticsWrapper {
  static addProgressionEvent (status, event) {
    if (active) {
      try {
        gameanalytics.GameAnalytics.addProgressionEvent(status, event)
      } catch (err) {
        // console.log(err)
      }
    }
  }
}
